__turbopack_context__.v({
  "hairline": "sign-up-module-scss-module__A_XC8a__hairline",
  "loginPicture": "sign-up-module-scss-module__A_XC8a__loginPicture",
  "logo": "sign-up-module-scss-module__A_XC8a__logo",
  "signIn": "sign-up-module-scss-module__A_XC8a__signIn",
  "signUpContainer": "sign-up-module-scss-module__A_XC8a__signUpContainer",
  "signUpForm": "sign-up-module-scss-module__A_XC8a__signUpForm",
});
